// extracted by mini-css-extract-plugin
module.exports = {"content":"OrderSelector_content__1BJg_","submitBtn":"OrderSelector_submitBtn__11ktj"};